export default "__VITE_ASSET__xGomPYjg__"